import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && _indexOfInstanceProperty(e).call(e, p) < 0) t[p] = s[p];

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (_indexOfInstanceProperty(e).call(e, p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState, useEffect } from 'react';
import Notice from '../notice';

const HookNotice = (_a, ref) => {
  var {
    afterClose
  } = _a,
      config = __rest(_a, ["afterClose"]);

  const [visible, setVisible] = useState(true);

  const close = () => {
    setVisible(false);
  };

  React.useImperativeHandle(ref, () => ({
    close: () => {
      setVisible(false);
    }
  }));
  useEffect(() => {
    if (!visible) {
      afterClose(String(config.id));
    }
  }, [visible]);
  return visible ? /*#__PURE__*/React.createElement(Notice, _Object$assign({}, config, {
    onHookClose: close
  })) : null;
};

export default /*#__PURE__*/React.forwardRef(HookNotice);